<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('progTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('progSubTitle')" class="pb-2"></span>
            </h1>

            <!-- <div class="card mb-3">
              <div class="card-body card-chart-body">
                <div class="row">
                  <div class="col-8 border-r-d mt-2 mb-2">
                    <span
                      class="pb-1"
                      v-text="$ml.get('approvedReports')"
                    ></span>
                    <h6>{{ approved_reports }}</h6>
                  </div>
                  <div class="col-8 border-r-d pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('scope')"></span>
                    <h6>{{ amount_of_scopes }}</h6>
                  </div>
                  <div class="col-8 pl-3 mt-2 mb-2">
                    <span class="pb-1" v-text="$ml.get('navAverage')"></span>
                    <h6>{{ mediaRecomp }}</h6>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="col-sm-12 my-3">
              <div class="input-group">
                <input
                  class="form-control filterInput"
                  v-model="search"
                  :placeholder="$ml.get('titleProgram')"
                  aria-label="Search"
                  style="border-right: none"
                  @input="waitAPI"
                />
                <div class="input-group-append">
                  <div class="input-group-text" style="background-color: #fff">
                    <svg width="20" height="20" class="mt-1">
                      <image
                        xlink:href="../../../../src/assets/icons/search_s.svg"
                        width="18"
                        height="18"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <div>
                <p
                  class="time ml-1 m-0 mt-1"
                  v-text="
                    $ml
                      .with('results', ammountOfPages)
                      .with('totalResults', totalPages)
                      .get('showingResultsOfTotal')
                  "
                >
                  Mostrando
                </p>
              </div>
            </div>
            <div v-if="loading" class="loading d-flex col-24 mb-4">
              <div class="c-loader"></div>
            </div>
            <div
              class="card col py-3 text-center mb-4"
              v-if="!loading && !listProgram.length"
            >
              <h6 class="p-1" v-text="$ml.get('noProgramAvailable')">
                Nenhum programa disponível
              </h6>
            </div>
            <div class="mb-3" v-show="listProgram.length">
              <div class="card">
                <div class="card-header" v-text="$ml.get('program') + 's'">
                  Programas
                </div>
                <ListProgram :list-program="listProgram" />
              </div>
            </div>
            <div v-show="totalPages > 10 && !loading" class="mb-2">
              <b-pagination
                v-model="pageActive"
                :total-rows="totalPages"
                :per-page="10"
                :prev-text="$ml.get('previous')"
                :next-text="$ml.get('next')"
                align="right"
              >
              </b-pagination>
            </div>
            <div class="card mb-3">
              <CardCreatProgram />
            </div>
          </div>
        </div>
        <!-- //- Cards do lado direito, Invite e Ranking -->
        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <CardResumeProgramVue
            :amount_of_scopes="amount_of_scopes"
            :approved_reports="approved_reports"
          />
          <section>
            <div class="mb-3">
              <Ranking />
            </div>
            <div v-if="itensIvite.length" class="card mb-3">
              <div class="card-header card-chart-mini">
                <div class="d-flex flex-row align-items-center">
                  <div class="mr-2">
                    <img
                      src="../../../../src/assets/icons/paper-plane-black.svg"
                      width="17"
                      height="17"
                    />
                  </div>
                  <span v-text="$ml.get('lastInvitations')"
                    >Ultimos Convites</span
                  >
                </div>
              </div>
              <div class="card-body py-1">
                <div
                  v-for="(item, index) in itensIvite"
                  :key="index"
                  class="d-column flex-row"
                >
                  <div
                    :class="
                      'h-profile d-flex align-items-center py-3 ' +
                      (itensIvite.length == index + 1 ? 'no' : '')
                    "
                  >
                    <div
                      class="position-relative align-self-center align-items-center align-self-center w50"
                    >
                      <object
                        width="42"
                        height="42"
                        class="rounded-circle img-m"
                        :data="item.program_avatar"
                        type="image/png"
                      >
                        <img
                          width="42"
                          height="42"
                          class="rounded-circle img-m"
                          src="../../../assets/images/default.png"
                          alt="Avatar"
                        />
                      </object>
                    </div>
                    <div class="flex-row align-items-start overflow-hidden">
                      <div class="align-self-center">
                        <h3
                          class="flex-wrap d-block"
                          v-text="item.username"
                        ></h3>
                        <p>
                          <a><span v-text="item.program_name"></span></a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import _ from "lodash";
import Ranking from "../../../components/ranking";
// import ScoreMultiplierIcon from "../../../components/ScoreMultiplierIcon";
import CardResumeProgramVue from "../../../components/CardResumeProgram.vue";
import ListProgram from "../../../components/ListProgram.vue";
import CompanyService from "../../../services/company.service";
import ProgramService from "../../../services/program.service";
export default {
  components: {
    Ranking,
    ListProgram,
    CardResumeProgramVue,
    // ScoreMultiplierIcon,
  },
  data() {
    return {
      title: "Program",
      loading: true,
      approved_reports: 0,
      amount_of_scopes: 0,
      mediaRecomp: "R$00,00-R$00,00",

      listProgram: [],
      itensIvite: [],
      currency: "",
      pageActive: 1,
      pageSize: 10,
      ammountOfPages: 0,
      totalPages: 0,
      search: "",
    };
  },
  created() {
    this.changeProgram();
    this.changeInvite();
    this.changeSummary();
  },
  mounted() {
    this.currency = this.$store.getters["getUser"]?.currency;
  },
  watch: {
    pageActive() {
      this.changeProgram();
    },
  },
  methods: {
    waitAPI: _.debounce(function () {
      this.changeProgram();
    }, 500),

    nameFilter({ name }) {
      return `${this.$ml.get(name)}`;
    },
    changeProgram() {
      this.loading = true;

      ProgramService.getProgram(
        "",
        this.pageActive,
        this.pageSize,
        this.search,
      ).then((response) => {
      this.listProgram = response?.data?.items?.filter(
        (p) => p?.status !== "archived"
      ) ?? [];
        this.totalPages = response?.data?.total;
        this.loading = false;

        if (this.listProgram) {
          if (this.listProgram.length == this.pageSize) {
            this.ammountOfPages = this.pageSize * this.pageActive;
          } else {
            this.ammountOfPages =
              this.pageSize * (this.pageActive - 1) +
              response.data.items.length;
          }
        }
      });
    },
    changeInvite() {
      ProgramService.getInvites(1, 3, "").then((response) => {
        this.itensIvite = response.data.items;
      });
    },
    changeSummary() {
      CompanyService.getGeneralSummary().then((response) => {
        this.approved_reports = response.data.approved_reports;
        this.amount_of_scopes = response.data.amount_of_scopes;
        this.mediaRecomp =
          response.data.min_bounty == response.data.max_bounty
            ? this.convertMoney(response.data.min_bounty)
            : this.convertMoney(response.data.min_bounty) +
              " - " +
              this.convertMoney(response.data.max_bounty);
      });
    },

    convertMoney(money) {
      money = parseFloat(money);
      return money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style scoped>
.overflow-hidden {
  overflow: hidden;
}
.w50 {
  width: 50px !important;
}

main section .h-profile img {
  margin-right: 13px !important;
}
</style>
